import React from 'react';
import { Translate } from 'core/translate';
import { Dagger } from '../notifications/NotificationsTrigger';
import { withNotifications } from '../notifications/NotificationsContext';

const OptionMsrpHeader = props => {
  const {
    msrp,
    hideLabel,
    analyticsKey,
    analyticsKey2,
    disclaimer,
    notifications
  } = props;
  const { disabled, showNamed } = notifications;

  const label = hideLabel ? null : (
    <span className="option__price-label">
      <Translate value="component.pricing.from.no.asterisk" />{' '}
    </span>
  );

  if (disabled) {
    return (
      <div className="text-right">
        {label}
        <span className="price option__price">{msrp}</span>
      </div>
    );
  }

  return (
    <div
      className="text-right option__selectable stat-disclaim"
      data-dtm={analyticsKey}
      data-dtm2={analyticsKey2}
      onClick={event => showNamed('msrp-simple', event)}>
      {label}
      <span className="price option__price disclaimer">
        {msrp} <Dagger />
      </span>
      <div className="show-for-sr">{disclaimer}</div>
    </div>
  );
};

export default withNotifications(OptionMsrpHeader);
